import { render } from "./renew-action-cell.vue?vue&type=template&id=494b269c&scoped=true&ts=true"
import script from "./renew-action-cell.vue?vue&type=script&lang=ts"
export * from "./renew-action-cell.vue?vue&type=script&lang=ts"

import "./renew-action-cell.vue?vue&type=style&index=0&id=494b269c&scoped=true&lang=css"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494b269c"]])

export default __exports__